module.exports = __webpack_public_path__ + "static/media/7.de31c476.jpg";